export class CreateThreatHuntingScanRequestRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return CreateThreatHuntingScanRequestRequest.attributeTypeMap;
    }
    constructor() {
    }
}
